module.exports = __webpack_public_path__ + "img/03271852000101.c4272016.png";